// extracted by mini-css-extract-plugin
export default {"container":"styles_container__G3R8K","controls":"styles_controls__IURzX","thumbnailSection":"styles_thumbnailSection__-uKaM"};